import React from 'react';
import { useTranslation } from 'react-i18next';
import * as icons from '@justgiving/icons';
import Svg from '@justgiving/svg';
import { formatEventDate } from '../../utils/eventDate';

import './EventCard.scss';

type EventCardProps = {
  name?: string;
  date?: number;
  className?: string;
};

const EventCard = ({ name, date, className = '' }: EventCardProps) => {
  const { t } = useTranslation();
  if (!name && !date) {
    return (
      <div data-qa="eventCard">
        <p>{t(['content.settings.event.noevent'])}</p>
      </div>
    );
  }

  return (
    <div data-qa="eventCard" className={`jg-tc-eventcard ${className}`}>
      <div className="jg-tc-eventcard__icon jg-flex-ass jg-space-mtxs">
        <Svg
          markup={icons.calendarIcon}
          className="jg-icon jg-icon--medium jg-fill--nobel"
        />
      </div>

      <div>
        <div className="jg-tc-eventcard__title" data-qa="event-card-name">
          {name}
        </div>
        {date && (
          <div className="jg-tc-eventcard__date" data-qa="event-card-date">
            {formatEventDate(date)}
          </div>
        )}
      </div>
    </div>
  );
};
export default EventCard;
